import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  class: "coupon-received-title",
  role: "status"
}
const _hoisted_2 = { class: "coupon-received-list" }
const _hoisted_3 = { class: "coupon-received-name" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "coupon-received-value" }
const _hoisted_6 = {
  key: 1,
  class: "coupon-received-generic",
  "aria-label": "优惠券到账提醒"
}
const _hoisted_7 = { class: "coupon-received-list" }
const _hoisted_8 = { class: "coupon-received-name" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "coupon-received-value" }

import {claimPopup,popupAvailable,releasePopup} from '@/utils/popupDisplay'
import {computed,nextTick,onBeforeUnmount,onMounted,ref,watch} from 'vue'
import {useRoute,useRouter} from 'vue-router'
import store from '@/store'
import customerRequest from '@/api/customer'
import request from '@/utils/request'
import ActivityCouponCard from '@/views/components/ActivityCouponCard.vue'
import {adminNoticeBlocking,couponReceiptBlocking} from '@/utils/adminNoticeRuntime'
import {couponReceiptIdentity,couponReceiptKey,couponReceiptSafePath,createCouponReceiptTracker,receiptActivity,couponReceiptSummaries,ReceivedCoupon,CouponReceiptScope} from '@/utils/couponReceipt'

export default /*#__PURE__*/_defineComponent({
  __name: 'CouponReceivedNotice',
  props: {
    ready: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {ready:boolean};

const popupOwner={}
const route=useRoute(),router=useRouter()
const visible=ref(false),notes=ref<ReceivedCoupon[]>([]),activity=ref<any>(null),tracker=createCouponReceiptTracker()
let serial=0,checking=false,disposed=false,poll:ReturnType<typeof setInterval>|undefined
let presentedIdentity='',presentedPath='',presentedOwner:CouponReceiptScope|null=null,renderReady=false,presentedNotes:ReceivedCoupon[]=[]
const identity=computed(()=>couponReceiptIdentity(props.ready,store.getters.token,store.getters.userInfo,store.getters.orgId,store.getters.orgInfo?.id))
const scope=()=>({orgId:Number(store.getters.orgId),customerId:Number(store.getters.userInfo?.id)})
const summaries=computed(()=>couponReceiptSummaries(notes.value))
const read=(key:string)=>localStorage.getItem(key)
function close(){releasePopup(popupOwner);visible.value=false;notes.value=[];activity.value=null;presentedIdentity='';presentedPath='';presentedOwner=null;presentedNotes=[];renderReady=false;couponReceiptBlocking.value=false}
function confirm(){
  if(!visible.value || !renderReady || !presentedOwner || disposed || document.visibilityState==='hidden' || adminNoticeBlocking.value
    || presentedIdentity!==identity.value || presentedPath!==route.path)return false
  if(!tracker.remember(presentedNotes,presentedOwner,read,(key,value)=>localStorage.setItem(key,value))){close();return false}
  close();return true
}
function invalidate(){serial++;checking=false;close()}
function safe(){
  return popupAvailable(popupOwner,'client-coupon-received-shell') && document.visibilityState!=='hidden' && !adminNoticeBlocking.value && couponReceiptSafePath(route.path)
    && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '')
    && !Array.from(document.querySelectorAll('.ant-modal-wrap:not(.client-coupon-received-shell), .ant-drawer-open')).some(el=>el.getClientRects().length>0 && getComputedStyle(el).visibility!=='hidden')
}
async function check(){
  if(disposed || checking || visible.value || !identity.value || !safe())return
  const current=++serial,who=identity.value,path=route.path,owner=scope()
  checking=true;couponReceiptBlocking.value=true
  const active=()=>!disposed && current===serial && who===identity.value && path===route.path && document.visibilityState!=='hidden'
  try{
    const [response,configuration]=await Promise.all([
      customerRequest.getMyValideNotesByCustomerId(owner.customerId),
      request({url:'fsystem/activityCoupon/campaigns',method:'GET',params:{orgId:owner.orgId}})
        .catch(()=>request({url:'fsystem/activityCoupon',method:'GET',params:{orgId:owner.orgId}}).catch(()=>null))
    ])
    if(!active() || !safe())return
    const incoming=tracker.unseen(response.data,owner,read)
    if(!incoming.length || !claimPopup(popupOwner,'client-coupon-received-shell'))return
    presentedIdentity=who;presentedPath=path;presentedOwner=owner
    notes.value=incoming;activity.value=receiptActivity(configuration?.data,incoming,owner.orgId);visible.value=true
    await nextTick()
    if(!active() || !safe()){if(current===serial)close();return}
    const remaining=tracker.unseen(incoming,owner,read)
    if(!remaining.length){close();return}
    notes.value=remaining;activity.value=receiptActivity(configuration?.data,remaining,owner.orgId);presentedNotes=remaining.map(note=>({...note}));renderReady=true
  }catch{/* 服务读取失败不误记已提醒，下轮仍可重试。 */}
  finally{if(current===serial){checking=false;if(!visible.value){couponReceiptBlocking.value=false;releasePopup(popupOwner)}}}
}
async function viewCoupons(){
  if(!identity.value)return
  const target=activity.value?.mode==='coupon'?{activityCouponId:String(activity.value.couponId),activityOrgId:String(scope().orgId)}:undefined
  if(confirm())await router.push({path:'/main/cuscenter/notes',query:target})
}
function visibility(){invalidate();if(document.visibilityState!=='hidden')void check()}
function storage(event:StorageEvent){
  const owner=scope(),prefix=couponReceiptKey(owner,0).replace(/0$/,'')
  if(event.key?.startsWith(prefix)){invalidate();void check()}
}
watch(identity,()=>{invalidate();void check()},{immediate:true})
watch(()=>route.path,()=>{invalidate();void check()})
watch(adminNoticeBlocking,blocked=>{if(blocked)invalidate();else void check()})
onMounted(()=>{
  document.addEventListener('visibilitychange',visibility);window.addEventListener('storage',storage)
  poll=setInterval(()=>void check(),15000)
})
onBeforeUnmount(()=>{disposed=true;invalidate();clearInterval(poll);document.removeEventListener('visibilitychange',visibility);window.removeEventListener('storage',storage)})

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: visible.value && !_unref(adminNoticeBlocking),
    footer: null,
    closable: false,
    "mask-closable": false,
    keyboard: false,
    width: 286,
    centered: "",
    "wrap-class-name": "client-coupon-received-shell",
    "body-style": {padding:'0',background:'transparent'}
  }, {
    default: _withCtx(() => [
      (activity.value)
        ? (_openBlock(), _createBlock(ActivityCouponCard, {
            key: 0,
            config: activity.value,
            compact: "",
            concise: ""
          }, {
            before: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, "收到" + _toDisplayString(notes.value.length) + "张优惠券", 1)
            ]),
            summary: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaries), (row) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: row.key
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", null, _toDisplayString(row.name), 1),
                      (row.count>1)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_4, "×" + _toDisplayString(row.count), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("b", null, _toDisplayString(row.benefit), 1),
                      _createElementVNode("span", null, _toDisplayString(row.condition), 1)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(row.scope), 1),
                    _createElementVNode("time", null, "截至 " + _toDisplayString(row.deadline), 1)
                  ]))
                }), 128))
              ])
            ]),
            actions: _withCtx(() => [
              _createElementVNode("div", { class: "coupon-received-actions" }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: viewCoupons
                }, "查看优惠券"),
                _createElementVNode("button", {
                  type: "button",
                  class: "primary",
                  onClick: confirm
                }, "知道了")
              ])
            ]),
            _: 1
          }, 8, ["config"]))
        : (_openBlock(), _createElementBlock("section", _hoisted_6, [
            _createElementVNode("h2", null, "收到" + _toDisplayString(notes.value.length) + "张优惠券", 1),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaries), (row) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: row.key
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(row.name), 1),
                    (row.count>1)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_9, "×" + _toDisplayString(row.count), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("b", null, _toDisplayString(row.benefit), 1),
                    _createElementVNode("span", null, _toDisplayString(row.condition), 1)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(row.scope), 1),
                  _createElementVNode("time", null, "截至 " + _toDisplayString(row.deadline), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", { class: "coupon-received-actions" }, [
              _createElementVNode("button", {
                type: "button",
                onClick: viewCoupons
              }, "查看优惠券"),
              _createElementVNode("button", {
                type: "button",
                class: "primary",
                onClick: confirm
              }, "知道了")
            ])
          ])),
      _createElementVNode("button", {
        class: "activity-close",
        type: "button",
        "aria-label": "关闭优惠券到账提醒",
        onClick: confirm
      }, "×")
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})